export const CommonPurchaseTaxes = {} as const
